<template>
  <!-- 数据字典管理 -->
  <div class="dataDict" data-app="true">
    <div class="parentPage" v-if="$route.name === 'dictList'">
      <mrc_ess_table
        :headers="headers"
        :hideAddBtn="!hasBtn('add-data-dictionary-entry')"
        pageName="add-dictionary"
        :paginationOptions="params"
        @turnPage="getData"
        :isLoading="loading"
        :slotKey="['is_used', 'dict_name', 'dict_label']"
        :items="desserts"
      >
        <template v-slot:search>
          <v-row
            class="d-flex justify-end"
            style="
              background: white;
              margin: 0;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;
              padding: 0 16px;
            "
          >
            <mrc_ess_advanceFilterAndSearchInput
              class="mt-4"
              v-model="systemSeniorQueryString"
              @success="getData({ cpage: 1 })"
              :systemFieldMeta="systemFieldMeta"
            ></mrc_ess_advanceFilterAndSearchInput>
          </v-row>
        </template>
        <template v-slot:item.is_used="{ item }">
          <!-- @click="editStatus(item.uuid,index)" -->
          <mrc_ess_viewbtn
            :is_used="item.is_used_save_value"
            :label="item.is_used"
          ></mrc_ess_viewbtn>
        </template>
        <template v-slot:item.dict_name="{ item }">
          {{ INT(item.dict_name) }}
        </template>
        <template v-slot:item.dict_label="{ item }">
          {{ INT(item.dict_label) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <menu-list
            :list="showList(item)"
            @handleClick="handleClick($event, item)"
          >
            <template v-slot:showAction>
              <v-icon
                v-btnAuth="[
                  'view-data-dictionary-entry',
                  'edit-data-dictionary-entry',
                  'delete-data-dictionary-entry',
                ]"
                >mdi-dots-vertical</v-icon
              >
            </template>
          </menu-list>
          <!-- <v-menu offset-y
                  transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-dots-vertical</v-icon>
            </template>
            <v-list>
              <v-list-item @click="edit_dict(item.dict_name, item.uuid, item.change)">
                <v-list-item-title>{{$t('label_Edit')}}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="!item.change"
                           @click="del_dict(item.uuid)">
                <v-list-item-title>{{$t('label_delete')}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
        </template>
      </mrc_ess_table>
    </div>
    <!-- 这是当前页的子页面  嵌套路由 -->
    <transition name="fade-transform" mode="out-in" v-else>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { getList, getDelete } from "@/service/api/data_dictionary";
import confirm from "@/components/confirm";
// import MrcTable from '@/components/MrcTable'
export default {
  components: { confirm },
  props: {},
  data() {
    return {
      systemSeniorQueryString: [],
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      toolList: [
        { name: this.$t("label_Edit") },
        { name: this.$t("label_delete") },
      ],
      loading: false,
      isLoading: false,
      params: {
        "~table~": "mrbase_sys_dict",
        cpage: this.$store.state.cpage,
        pagesize: this.$store.state.pageSize,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
      desserts: [],
    };
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  async mounted() {
    await this.getData();
  },
  beforeDestroy() {},
  methods: {
    showList(item) {
      const del = {
        name: this.$t("label_delete"),
        show: this.hasBtn("delete-data-dictionary-entry"),
      };
      const arr = [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-data-dictionary-entry"),
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-data-dictionary-entry"),
        },
      ];
      if (!item.change) {
        arr.push(del);
      }
      return arr;
    },
    // 获取list数据
    async getData(obj) {
      if (obj) {
        const { cpage, pagesize } = obj;

        this.params = { ...this.params, ...obj };
      }
      this.loading = true;
      const data = await getList({
        cpage: this.params.cpage,
        pagesize: this.params.pagesize,
        "~table~": "mrbase_sys_dict",
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      this.desserts = data.data;
      this.params.totalpage = data.totalpage;
      this.params.totalcount = data.totalcount;
      this.systemFieldMeta = data.systemFieldMeta;
      this.field_alias_name = data.field_alias_name;
      this.table_alias_name = data.table_alias_name;
      this.loading = false;
    },
    // 修改状态
    editStatus(id, index) {},
    handleClick({ index }, item) {
      if (index == 0) {
        this.$store.commit("set_subPage_name", item.dict_name);
        this.$store.commit("set_uuid", item.uuid);
        this.$store.commit("set_change", item.is_change);
        this.$store.commit("set_iconstatus", true);
        this.$router.push({
          name: "detail-dictionary",
          params: {
            name: item.dict_name,
            uuid: item.uuid,
            is_change: item.is_change,
          },
        });
      }
      // 编辑
      if (index == 1) {
        this.edit_dict(item.dict_name, item.uuid, item.change);
      }
      if (index == 2) {
        this.del_dict(item.uuid);
      }
    },
    // 编辑字典
    edit_dict(name, uuid, is_change) {
      this.$store.commit("set_subPage_name", name);
      this.$store.commit("set_uuid", uuid);
      this.$store.commit("set_change", is_change);
      this.$store.commit("set_iconstatus", false);
      this.$router.push({
        name: "detail-dictionary",
        params: {
          name,
          uuid,
          is_change,
        },
      });
    },
    // 删除字典
    del_dict(id) {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          this.isLoading = true;
          const obj = Object.assign(
            {},
            { uuid: id, "~table~": "mrbase_sys_dict" }
          );
          const del = await getDelete(obj);
          if (del.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
          }
          this.isLoading = false;
          // this.desserts.length === 1  只有一条数据 删除就请求上一页的数据
          if (this.desserts.length === 1 && this.params.cpage > 1) {
            this.params.cpage--;
            this.totalpage--;
          }
          await this.getData();
        })
        .catch(() => {});
    },
    // 添加字典
    add_dict() {
      this.$store.commit("set_subPage_name", "");
      this.$store.commit("set_uuid", "");
      this.$router.push({ name: "add-dictionary" });
    },
  },
  computed: {
    headers() {
      const headers = [
        {
          text: this.$t("label_Name_of_the_dictionary"),
          align: "start",
          sortable: false,
          value: "dict_name",
          width: "30%",
        },
        {
          text: this.$t("label_Save_the_value"),
          align: "start",
          sortable: false,
          value: "dict_value",
          width: "30%",
        },
        {
          text: this.$t("label_Show_columns"),
          align: "start",
          sortable: false,
          value: "dict_label",
          width: "30%",
        },
        {
          text: this.$t("label_Whether_to_enable"),
          align: "start",
          sortable: false,
          value: "is_used",
          width: "10%",
        },
        {
          text: "",
          align: "end",
          sortable: false,
          value: "actions",
          width: "20%",
        },
      ];
      return headers;
    },
  },
  watch: {
    async $route(val) {
      if (val.name === "dictList") {
        this.showSkeleton = true;
        await this.getData();
        this.showSkeleton = false;
      }
    },
  },
};
</script>

<style scoped>
.dataDict {
  height: 100%;
}
.btnGroup {
  position: relative;
}
.addBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 10px;
  transform: rotateZ(45deg);
}
.searchBox {
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  background-color: #eeeef0;
  border-radius: 20px !important;
  height: 50px;
  margin-right: 20px;
}
.dataDict /deep/ .v-text-field__slot > input {
  border: none;
}
/* .status {
  color: #fff;
  background-color: #18a874;
  min-width: 40px;
  height: 25px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  font-size: 12px;
  display: inline-block;
  line-height: 25px;
  text-align: center;
}
.is_used {
  background-color: #dedede;
} */
</style>
